import { render, staticRenderFns } from "./ui-auth-view.vue?vue&type=template&id=06ad542d&scoped=true&"
import script from "./ui-auth-view.vue?vue&type=script&lang=js&"
export * from "./ui-auth-view.vue?vue&type=script&lang=js&"
import style0 from "./ui-auth-view.vue?vue&type=style&index=0&id=06ad542d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ad542d",
  null
  
)

export default component.exports